/**
 * Utilitaires de sécurité pour protéger l'application contre les inspections
 */

// Une technique pour obfusquer les noms de fichiers dans la console développeur
export const obfuscateSourceMapping = () => {
  try {
    // Supprime les informations de source-mapping qui révèlent les noms de fichiers
    const originalCreateElement = document.createElement;
    document.createElement = function (...args) {
      const element = originalCreateElement.apply(this, args);
      if (args[0].toLowerCase() === 'script') {
        setTimeout(() => {
          if (element.src && element.src.includes('sourcemap')) {
            element.removeAttribute('src');
          }
        }, 0);
      }
      return element;
    };
  } catch (e) {
    // Silencieux
  }
};

// Détecte et bloque l'ouverture des outils de développeur
// Fonction désactivée car elle cause des problèmes avec Safari mobile
export const blockDevTools = () => {
  // Fonction désactivée
  return;
};

// Fonction pour obfusquer un mot de passe
export const verifyPassword = (input, correctPassword) => {
  if (!input || !correctPassword) return false;
  
  // Simple vérification sans exposer le mot de passe en clair
  let hash = 0;
  for (let i = 0; i < correctPassword.length; i++) {
    hash = ((hash << 5) - hash) + correctPassword.charCodeAt(i);
    hash |= 0;
  }
  
  let inputHash = 0;
  for (let i = 0; i < input.length; i++) {
    inputHash = ((inputHash << 5) - inputHash) + input.charCodeAt(i);
    inputHash |= 0;
  }
  
  return hash === inputHash;
};

// Fonction d'initialisation à appeler au démarrage de l'application
export const initSecurity = () => {
  if (process.env.NODE_ENV === 'production') {
    obfuscateSourceMapping();
    // blockDevTools() a été retiré car il causait des problèmes avec Safari mobile
  }
};

export default {
  obfuscateSourceMapping,
  blockDevTools,
  verifyPassword,
  initSecurity
}; 